/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPercentage = createReactComponent("outline", "percentage", "IconPercentage", [["path", { "d": "M17 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M7 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M6 18l12 -12", "key": "svg-2" }]]);

export { IconPercentage as default };
//# sourceMappingURL=IconPercentage.mjs.map
